import { DefaultOptions } from "@apollo/client";

export const errorPolicies: DefaultOptions = {
  query: { errorPolicy: "all" },
  watchQuery: { errorPolicy: "all" },
};
